import { render, staticRenderFns } from "./eventManagement.vue?vue&type=template&id=3afbae78&scoped=true&"
import script from "./eventManagement.vue?vue&type=script&lang=js&"
export * from "./eventManagement.vue?vue&type=script&lang=js&"
import style0 from "./eventManagement.vue?vue&type=style&index=0&id=3afbae78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbae78",
  null
  
)

export default component.exports